import { produce } from 'immer';

import {
    SWAP_CORRECTION_MODE,
    CALCULATE_VOTE_TRAINING_START,
    CALCULATE_VOTE_TRAINING_SUCCESS,
    CALCULATE_VOTE_TRAINING_ERROR,
    INITIALIZE_LOCAL_STATUS,
    GET_STATUS_SUCCESS,
    GET_STATUS_ERROR,
    GET_STATUS_START,
    GET_STATUS_ARRAY_BY_ASSIGMENT_SUCCESS,
    GET_STATUS_ARRAY_BY_ASSIGMENT_ERROR,
    GET_STATUS_ARRAY_BY_ASSIGMENT_START,
    UPDATE_EXERCISE_STATUS,
    UPDATE_STATUS_START,
    UPDATE_STATUS_SUCCESS,
    UPDATE_STATUS_ERROR,
    PAUSE_HOMEWORK,
    UNPAUSE_HOMEWORK,
    START_HOMEWORK,
    TERMINATE_HOMEWORK,
    TICK_REMAININGTIME,
    SET_REMAINING_TIME,
    SELECT_EXERCISE,
    SHOW_EXERCISE_CORRECTION,
    RESET_CORRECTIONS_STATUS,
    SHOW_ALL_EXERCISES_CORRECTIONS,
    CORRECT_ALL_EXERCISES,
    UPDATE_HOMEWORK_VERSION,
    SAVE_SCORE_MODIFIER,
    GET_GOOGLE_STUDENTE_INFO_SUCCESS,
    GET_GOOGLE_STUDENTE_INFO_START,
    GET_GOOGLE_STUDENTE_INFO_ERROR,
    TERMINATE_SECTION,
    TERMINATE_SECTION_SUCCESS,
    TERMINATE_SECTION_ERROR,
    GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_START,
    GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_SUCCESS,
    GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_ERROR,
} from '../actions/status';

export const initialState = {
    id: null,
    answers: [],
    attemptsNumber: 0,
    correctionsStatus: [],
    exercisesCorrection: null,
    correctionPoints: [],
    isOldCorrection: null,
    currentExerciseIndex: 0,
    started: false,
    finished: false,
    modificationTime: '',
    homeworkVersion: null,
    paused: false,
    profileValues: {},
    resumed: false,
    expiringAssignment: null,
    remainingTime: null,
    resetTimerValue: null,
    randomSeed: null,
    scoreModifier: null,
    statusArray: [],
    httpStatus: {
        error: false,
        fetching: false,
        loaded: false,
        created: false,
        updating: false,
        errorbody: undefined,
        httpCode: null,
    },
    calculateVoteRequest: {
        cache: {
            tempScore: null,
            tempPoints: null,
        },
        error: false,
        fetching: false,
        loaded: false,
    },
    sections: null,
    statusArrayLoaded: true,
    student: {
        id: null,
        email: null,
        groupId: 0,
        firstName: null,
        lastName: null,
        role: null,
        error: false,
        fetching: false,
        loaded: true,
        isGoogle: false,
    },
    sendGradeError: false,
    simulationOfBookId: null,
};

export const reducer = produce((state = initialState, action = {}) => {
    switch (action.type) {
        case START_HOMEWORK:
            return {
                ...state,
                started: true,
                paused: false,
                resumed: false,
            };
        case INITIALIZE_LOCAL_STATUS: {
            const { finished, randomSeed, remainingTime } = action.payload;

            return {
                ...state,
                finished,
                randomSeed,
                remainingTime,
            };
        }
        case GET_STATUS_START:
            return {
                ...state,
                httpStatus: {
                    ...state.httpStatus,
                    error: false,
                    fetching: true,
                    loaded: false,
                    httpCode: null,
                },
            };
        case GET_STATUS_SUCCESS: {
            const correctionPoints = action.payload.corrections || [];
            delete action.payload.corrections;
            return {
                ...state,
                ...action.payload,
                correctionPoints: correctionPoints,
                isOldCorrection: state.isOldCorrection == null ? !correctionPoints.some((c) => !!c.totalAnswers) : state.isOldCorrection,
                httpStatus: { ...state.httpStatus, httpCode: null, fetching: false, loaded: true },
                student: { ...state.student, ...action.payload.student },
            };
        }
        case GET_STATUS_ERROR:
            return {
                ...state,
                httpStatus: {
                    ...state.httpStatus,
                    error: true,
                    fetching: false,
                    httpCode: action.payload.httpCode,
                },
            };
        case UPDATE_STATUS_START:
        case TERMINATE_SECTION:
            return {
                ...state,
                httpStatus: {
                    ...state.httpStatus,
                    updating: true,
                },
            };
        case UPDATE_STATUS_SUCCESS:
            return {
                ...state,
                ...action.payload.status,
                httpStatus: {
                    ...state.httpStatus,
                    updating: false,
                    httpCode: null,
                    errorbody: undefined,
                },
            };
        case UPDATE_STATUS_ERROR: {
            let answers = [];
            if (state.httpStatus.errorbody && state.httpStatus.errorbody.answers) answers = state.httpStatus.errorbody.answers;
            if (action.payload.body.answers) {
                action.payload.body.answers.forEach((answer) => {
                    answers = answers.filter((x) => x.exerciseId !== answer.exerciseId);
                    answers.push(answer);
                });
            }

            return {
                ...state,
                httpStatus: {
                    ...state.httpStatus,
                    updating: false,
                    httpCode: action.payload.httpCode,
                    errorbody: { ...state.httpStatus.errorbody, ...action.payload.body, answers },
                },
            };
        }
        case TERMINATE_SECTION_SUCCESS: {
            const newState = action.payload;

            return {
                ...state,
                ...newState,
                resetTimerValue: newState.remainingTime,
                httpStatus: {
                    ...state.httpStatus,
                    updating: false,
                    httpCode: null,
                    errorbody: undefined,
                },
            };
        }
        case TERMINATE_SECTION_ERROR:
            return {
                ...state,
                httpStatus: {
                    ...state.httpStatus,
                    updating: false,
                    httpCode: action.payload.httpCode,
                },
            };
        case UPDATE_EXERCISE_STATUS: {
            const exercise = state.answers.find((x) => x.exerciseId === action.payload.exerciseId);
            if (exercise) {
                exercise.answer = action.payload.answer;
            } else {
                state.answers.push(action.payload);
            }
            break;
        }
        case PAUSE_HOMEWORK:
            return {
                ...state,
                paused: true,
                started: false,
            };
        case UNPAUSE_HOMEWORK:
            return {
                ...state,
                paused: false,
                started: true,
            };
        case UPDATE_HOMEWORK_VERSION:
            return {
                ...state,
                homeworkVersion: action.payload.homeworkVersion,
            };
        case TERMINATE_HOMEWORK:
            return {
                ...state,
                finished: true,
                exercisesCorrection: action.payload.correction,
                sendGradeError: action.payload.sendGradeError,
            };
        case TICK_REMAININGTIME:
            return {
                ...state,
                remainingTime: state.remainingTime - 1,
            };
        case SET_REMAINING_TIME: {
            const newRemainingTime = action.payload.value;
            const values = {
                resetTimerValue: newRemainingTime,
            };
            if (Number.isInteger(newRemainingTime)) {
                values.remainingTime = newRemainingTime;
            }

            return {
                ...state,
                ...values,
            };
        }
        case SELECT_EXERCISE: {
            return {
                ...state,
                currentExerciseIndex: action.payload.index,
            };
        }
        case SHOW_EXERCISE_CORRECTION:
            return {
                ...state,
                correctionsStatus: [
                    ...state.correctionsStatus,
                    {
                        exerciseId: action.payload.exerciseId,
                        state: action.payload.state,
                    },
                ],
            };
        case RESET_CORRECTIONS_STATUS:
            return {
                ...state,
                correctionsStatus: [],
            };
        case CORRECT_ALL_EXERCISES:
        case SHOW_ALL_EXERCISES_CORRECTIONS:
            return {
                ...state,
                correctionsStatus: action.payload,
            };
        case GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_START:
        case GET_STATUS_ARRAY_BY_ASSIGMENT_START:
            return {
                ...state,
                statusArray: [],
                attemptsNumber: 0,
                statusArrayLoaded: false,
            };
        case GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_SUCCESS:
        case GET_STATUS_ARRAY_BY_ASSIGMENT_SUCCESS:
            return {
                ...state,
                statusArray: action.payload,
                attemptsNumber: action.payload.length,
                attemptsNumberFinished: action.payload.filter((att) => att.finished).length,
                statusArrayLoaded: true,
            };
        case GET_STATUS_ARRAY_BY_GOOGLE_CLASSROOM_ADDON_SUBMISSION_ERROR:
        case GET_STATUS_ARRAY_BY_ASSIGMENT_ERROR:
            return {
                ...state,
                statusArray: [],
                attemptsNumber: 0,
                statusArrayLoaded: true,
            };
        case SAVE_SCORE_MODIFIER:
            return {
                ...state,
                scoreModifier: action.payload.scoreModifier,
            };
        case CALCULATE_VOTE_TRAINING_START:
            return {
                ...state,
                calculateVoteRequest: {
                    ...state.calculateVoteRequest,
                    error: false,
                    fetching: true,
                    loaded: false,
                },
            };
        case CALCULATE_VOTE_TRAINING_SUCCESS: {
            const tempCorrectionPoints = state.correctionPoints || [];
            const tempScore = state.score;
            return {
                ...state,
                score: null,
                correctionPoints: action.payload,
                calculateVoteRequest: {
                    cache: { tempScore: tempScore, tempPoints: tempCorrectionPoints },
                    error: false,
                    fetching: false,
                    loaded: true,
                },
            };
        }
        case CALCULATE_VOTE_TRAINING_ERROR:
            return {
                ...state,
                calculateVoteRequest: {
                    ...state.calculateVoteRequest,
                    error: true,
                    fetching: false,
                    loaded: false,
                },
            };
        case SWAP_CORRECTION_MODE: {
            const cachedPoints = state.calculateVoteRequest.cache.tempPoints;
            const cachedScore = state.calculateVoteRequest.cache.tempScore;
            return {
                ...state,
                correctionPoints: cachedPoints,
                score: cachedScore,
                calculateVoteRequest: {
                    ...state.calculateVoteRequest,
                    cache: { tempPoints: state.correctionPoints, tempScore: state.score },
                },
            };
        }
        case GET_GOOGLE_STUDENTE_INFO_SUCCESS:
            return {
                ...state,
                student: {
                    ...state.student,
                    id: action.payload.userId,
                    email: null,
                    groupId: 14,
                    firstName: action.payload.profile.name.givenName,
                    lastName: action.payload.profile.name.familyName,
                    role: 'Studente / Student',
                    error: false,
                    fetching: false,
                    loaded: true,
                },
            };
        case GET_GOOGLE_STUDENTE_INFO_START:
            return {
                ...state,
                student: {
                    ...state.student,
                    error: false,
                    fetching: true,
                    loaded: false,
                    isGoogle: true,
                },
            };
        case GET_GOOGLE_STUDENTE_INFO_ERROR:
            return {
                ...state,
                student: {
                    ...state.student,
                    error: true,
                    fetching: false,
                    loaded: true,
                },
            };
        default:
            return state;
    }
});
